'use strict';

(function () {
  'use strict';

  angular.module('vnext').config(['$stateProvider', 'InspirationDetailRouterProvider', function ($stateProvider, InspirationDetailRouterProvider) {

    $stateProvider.state('vnext.content.inspirations', {
      abstract: true,
      url: 'inspirations',
      default: '.list',
      templateUrl: 'vnext/pages/inspirations/inspirations.html',
      data: {
        pageTitle: 'pageTitles.inspirations'
      }
    }).state('vnext.content.inspirations.list', {
      abstract: true,
      url: '',
      default: '.category',
      controllerAs: 'vm',
      controller: 'InspirationsListCtrl',
      templateUrl: 'vnext/pages/inspirations/inspirations-list.html'
    }).state({
      name: 'vnext.content.inspirations.list.category',
      url: '/{type:(?:popular|new)}',
      controller: 'InspirationsCtrl',
      controllerAs: 'vm',
      templateUrl: 'vnext/pages/inspirations/inspirations-list-content.html',
      params: {
        type: {
          value: 'popular',
          squash: true
        }
      }
    }).state(InspirationDetailRouterProvider.buildRoutes('vnext.content.inspirations.list.category').modal).state(InspirationDetailRouterProvider.buildRoutes('vnext.content.inspirations.list.category').detail).state('vnext.content.inspirations.list.my', {
      url: '/my',
      controller: 'UserInspirationsCtrl',
      controllerAs: 'vm',
      templateUrl: 'vnext/pages/inspirations/inspirations-list-content.html',
      resolve: {
        inspirations: ['$stateParams', 'inspirationSvc', function ($stateParams, inspirationSvc) {
          return inspirationSvc.get('my');
        }],
        userAlias: function userAlias() {
          return null;
        }
      },
      params: {
        disableInspirationBrowsing: true
      }
    }).state(InspirationDetailRouterProvider.buildRoutes('vnext.content.inspirations.list.my').modal).state(InspirationDetailRouterProvider.buildRoutes('vnext.content.inspirations.list.my').detail).state('vnext.content.inspirations.list.profile', {
      url: '/user/:userId',
      controller: 'UserInspirationsCtrl',
      controllerAs: 'vm',
      templateUrl: 'vnext/pages/inspirations/inspirations-list-content.html',
      resolve: {
        inspirations: ['$stateParams', 'inspirationSvc', function ($stateParams, inspirationSvc) {
          return inspirationSvc.findByUser($stateParams.userId);
        }],
        userAlias: ['inspirations', function (inspirations) {
          return inspirations[0].userAlias;
        }]
      },
      params: {
        disableInspirationBrowsing: true
      }
    }).state(InspirationDetailRouterProvider.buildRoutes('vnext.content.inspirations.list.profile').modal).state(InspirationDetailRouterProvider.buildRoutes('vnext.content.inspirations.list.profile').detail).state('vnext.content.inspirations.list.manage', {
      url: '/manage',
      views: {
        '@vnext.content.inspirations.list': {
          templateUrl: 'vnext/pages/inspirations/manage.html',
          controller: 'InspirationsManageCtrl',
          controllerAs: 'vm'
        }
      },
      resolve: {
        inspirations: ['inspirationSvc', function (inspirationSvc) {
          return inspirationSvc.getType('uploaded');
        }]
      },
      params: {
        disableInspirationBrowsing: true
      }
    }).state(InspirationDetailRouterProvider.buildRoutes('vnext.content.inspirations.list.manage').modal).state(InspirationDetailRouterProvider.buildRoutes('vnext.content.inspirations.list.manage').detail).state('vnext.content.inspirations.upload', {
      url: '/upload',
      templateUrl: 'vnext/pages/inspirations/upload.html',
      controller: 'InspirationsUploadCtrl',
      controllerAs: 'vm',
      resolve: {
        inspirations: ['inspirationSvc', function (inspirationSvc) {
          return inspirationSvc.getType('uploaded');
        }]
      }
    });
  }]);
})();